var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66797C8.89494 1.66797 7.83513 2.10696 7.05373 2.88836C6.27233 3.66976 5.83334 4.72957 5.83334 5.83464C5.83334 6.9397 6.27233 7.99951 7.05373 8.78091C7.83513 9.56232 8.89494 10.0013 10 10.0013C11.1051 10.0013 12.1649 9.56232 12.9463 8.78091C13.7277 7.99951 14.1667 6.9397 14.1667 5.83464C14.1667 4.72957 13.7277 3.66976 12.9463 2.88836C12.1649 2.10696 11.1051 1.66797 10 1.66797ZM15.0088 11.668H4.99126C4.07709 11.668 3.33334 12.4117 3.33334 13.3259V13.9596C3.33334 15.3396 4.11876 16.533 5.54459 17.3192C6.73084 17.9742 8.31334 18.3346 10 18.3346C13.2108 18.3346 16.6667 16.9655 16.6667 13.9596V13.3259C16.6667 12.4117 15.9229 11.668 15.0088 11.668Z",
    fill: "#FFFCEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic_user.be5eb175659d7da75e1119c2602e9e80.svg";
export { ForwardRef as ReactComponent };